import _objectSpread2 from '../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import { block } from '../../utils/block.js';
import './Card.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const _excluded = ["header", "subHeader", "className"];
const b = block('card');
const CardHeader = _ref => {
  let {
      header,
      subHeader,
      className = ''
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs("header", _objectSpread2(_objectSpread2({
    className: b('header').mix(className)
  }, rest), {}, {
    children: [/*#__PURE__*/jsx("h1", {
      className: b('h1'),
      "data-heap-redact-text": true,
      children: header
    }), /*#__PURE__*/jsx("h2", {
      className: b('h2'),
      "data-heap-redact-text": true,
      children: subHeader
    })]
  }));
};

export { CardHeader };
